<template>
  <v-expansion-panel>
    <v-expansion-panel-title v-slot="{ expanded }">
      <v-row no-gutters>
        <v-col cols="4" class="text-primary "> Bon de Retour </v-col>
        <v-col cols="8" class="text-medium-emphasis">
          <v-fade-transition leave-absolute>
            <span v-if="expanded" key="edit"> Editer le bon puis sauvegarder </span>
            <div v-else key="summary">
              <div v-if="bonRetour.account">
                {{ bonRetour.account.name }}
              </div>
              <div v-if="bonRetour.laverie">/ {{ bonRetour.laverie.name }}</div>
            </div>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="bonRetour.account" :items="accounts" item-title="name" return-object
            label="Siège"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le compte siège
        </v-col>
      </v-row>

      <v-row v-if="bonRetour.account" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="bonRetour.laverie" :items="laveries" item-title="name" return-object
            label="Laverie"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la laverie
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.laverie" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-checkbox v-for="(p, index) in products" :key="index" v-model="bonRetour.selectedProducts"
            :label="`${p.productType} : ${p.aquaNb}`" :value="p"></v-checkbox>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> <br />Selectionnez les produits à enlever </v-col>
      </v-row>
      <v-row v-if="bonRetour.laverie && bonRetour.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="1" class="pr-1">
          <v-text-field name="numero" hint="Le numéro dans la rue" v-model="bonRetour.laverie.address.numero"
             label="Numero">
          </v-text-field>
        </v-col>
        <v-col cols="5" class="pl-1">
          <v-text-field name="rue" hint="Le nom de la rue" v-model="bonRetour.laverie.address.rue"
             label="Rue">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Changez l'adresse si nécessaire
        </v-col>
      </v-row>

      <template v-if="bonRetour.laverie && bonRetour.laverie.address">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="1" class="pr-1">
            <v-text-field name="codepostale" hint="Le code postale de la ville"
              v-model="bonRetour.laverie.address.codepostale"  label="Code Postale">
            </v-text-field>
          </v-col>
          <v-col cols="5" class="pl-1">
            <v-text-field name="ville" hint="Le nom de la ville" v-model="bonRetour.laverie.address.ville"
               label="Ville">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
            <v-col cols="2" class="pr-1">
            <v-text-field name="etage" v-model="bonRetour.accessibility.etage" 
              label="Etage">
            </v-text-field>
          </v-col>
            <v-col cols="2" class="px-1">
            <v-text-field name="ascenseur" v-model="bonRetour.accessibility.ascenseur" 
              label="Ascenseur">
            </v-text-field>
          </v-col>
            <v-col cols="2" class="pl-1">
            <v-text-field name="escalier" v-model="bonRetour.accessibility.escalier" 
              label="Escalier">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Détaillez l'accessibilité
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="2" class="pr-1">
            <v-text-field name="codePorte" v-model="bonRetour.laverie.codeAcces" 
              label="Code Porte">
            </v-text-field>
          </v-col>
          <v-col cols="2" class="px-1">
            <v-text-field name="parkingPrive" v-model="bonRetour.accessibility.parking" 
              label="Parking Privé">
            </v-text-field>
          </v-col>
          <v-col cols="2" class="pl-1">
            <v-text-field name="cle" v-model="bonRetour.accessibility.key"  label="Clé">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
      </template>

      <v-row v-if="bonRetour.laverie" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field v-model="bonRetour.pickupDate" type="date">
            <template #label>
              Rendez-vous<span class="text-red"><strong> *</strong></span>
            </template>
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la date d'enlèvement
        </v-col>
      </v-row>

      <template v-if="bonRetour.pickupDate">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="gestionnaire" hint="Nom et prénom du gestionnaire"
              v-model="bonRetour.laverie.gestionnaire"  label="Gestionnaire">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Changez le gestionnaire si nécessaire
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="3" class="pr-1">
            <v-text-field name="gestionnaireMobile" hint="Mobile du gestionnaire"
              v-model="bonRetour.laverie.telephonePrincipal"  label="Mobile">
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pl-1">
            <v-text-field name="gestionnaireTel" hint="Téléphone du gestionnaire"
              v-model="bonRetour.laverie.telephoneAutre"  label="Téléphone">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="contactSecondPrenom" hint="Nom et prénom du contact secondaire"
              v-model="bonRetour.contactSecond.name"  label="Autre contact">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Renseignez un contact secondaire
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="3" class="pr-1">
            <v-text-field name="contactSecondMobile" hint="Mobile du contact secondaire"
              v-model="bonRetour.contactSecond.mobile"  label="Mobile">
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pl-1">
            <v-text-field name="contactSecondTel" hint="Téléphone du contact secondaire"
              v-model="bonRetour.contactSecond.telephone"  label="Téléphone">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="contactSecondFonction" hint="Fonction technique du contact secondaire"
              v-model="bonRetour.contactSecond.fonction"  label="Fonction">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-autocomplete v-model="bonRetour.motifRetour" :items="motifRetours" label="Motif du retour"></v-autocomplete>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Choisissez le motif du retour
          </v-col>
        </v-row>
      </template>

      <v-row v-if="bonRetour.motifRetour" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="bonRetour.enleverPar" :items="enleverPars" label="A enlever par"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonRetour.enleverPar && bonRetour.enleverPar == enleverParAutre" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field name="enleverParAutre" v-model="bonRetour.enleverParText" 
            label="Précisez">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonRetour.enleverPar" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field v-model="bonRetour.receivedDate" type="date">
            <template #label>
              Date retour<span class="text-red"><strong> *</strong></span>
            </template>
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la date de retour atelier
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.receivedDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field name="bonRetourObservations" hint="Observations" v-model="bonRetour.observations"
             label="Observations">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Notez les observations
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onCancel" text color="red"> Cancel </v-btn>
        <generate-doc-btn :filePath="bonRetourTemplatePath" :fileName="bonRetourFileName"
          :dataSet="bonRetourGen">Save</generate-doc-btn>
      </v-card-actions>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import GenerateDocBtn from "@/components/GenerateDocBtn.vue";
import type { Accessibility } from "@/types";
import type { User } from "@/types";
import { BonRetour, EnleverPar, MotifRetour } from "@/types";
import { flattenBonRetour } from "@/types";
import type { Account } from "@/types";
import type { Laverie } from "@/types";
import { getLaveriesByAccountId } from "@/utils/laverie-api";
import type { Product } from "@/types";
import { getProductsByLaverieId } from "@/utils/product-api";

interface Props {
  accounts: Account[];
  users: User[];
}

const props = defineProps<Props>();

const bonRetour = ref<BonRetour>({
  accessibility: {} as Accessibility,
  contactSecond: {} as User,
  selectedProducts: [],
} as BonRetour);


const bonRetourGen = computed(() =>
  flattenBonRetour(bonRetour.value)
);

const laveries = ref<Laverie[]>([]);
const products = ref<Product[]>([]);

const enleverParAutre = EnleverPar.AUTRE;
const enleverPars = Object.values(EnleverPar);
const motifRetours = Object.values(MotifRetour);

const bonRetourTemplatePath = "templates/BonRetourTemplate.docx";

const bonRetourFileName = computed(() => {
  if (bonRetour.value.laverie) {
    return "BonDeRetour_".concat(bonRetour.value.laverie.name);
  }
  return "BonDeRetour";
});

watch(
  () => bonRetour.value.account,
  async (selectedAccount) => {
    if (!selectedAccount) return;

    // Reset selected laverie
    bonRetour.value.laverie = null;
    laveries.value = [];

    await fetchLaveries(selectedAccount.id);
  }
);

watch(
  () => bonRetour.value.laverie,
  async (selectedLaverie) => {
    if (!selectedLaverie) return;

    bonRetour.value.selectedProducts = [];
    products.value = [];
    await fetchProducts(selectedLaverie.id);
  }
);

const fetchProducts = async (laverieId: string) => {
  try {
    products.value = await getProductsByLaverieId(laverieId);
  } catch (error) {
    console.error("Error fetching products:", error);
    products.value = [];
  }
};

const fetchLaveries = async (accountId: string) => {
  try {
    laveries.value = await getLaveriesByAccountId(accountId);
  } catch (error) {
    console.error("Error fetching laveries:", error);
    laveries.value = [];
  }
};

const onCancel = () => {
  // TODO clear form
  bonRetour.value = {
    accessibility: {} as Accessibility,
    contactSecond: {} as User,
    selectedProducts: [],
  } as BonRetour;

  laveries.value = [];
  products.value = [];
};
</script>
